const value = (source, key) =>
  source && typeof source.get === "function" ? source.get(key) : source?.[key];

const terminalStatuses = new Set([
  "uplifted",
  "no_change",
  "identity_mismatch",
  "failed_soft",
  "timed_out",
  "skipped",
  "unexpected_result",
]);

export const offerView = ({
  attempt,
  error,
  hasAttempt,
  loading,
  preAttemptCanContinue,
} = {}) => {
  const status = value(attempt, "status");

  if (
    loading &&
    !["offered", "link_ready", "processing"].includes(status) &&
    !(preAttemptCanContinue === true && !hasAttempt)
  ) {
    return "loading";
  }

  if (value(error, "network")) return "error";
  if (value(error, "http_status") === 422) {
    if (["invalid_account", "attempt_not_link_ready", "invalid_request"].includes(value(error, "reason_code")) &&
        ["offered", "link_ready"].includes(status)) return "offer";
    return "unavailable";
  }
  if (status === "processing") return "processing";
  if (error) return "error";

  if (!hasAttempt) {
    if (preAttemptCanContinue == null) return "loading";
    return preAttemptCanContinue === false ? "unavailable" : "offer";
  }

  if (["offered", "link_ready"].includes(status)) return "offer";
  if (terminalStatuses.has(status)) return "terminal";

  return "error";
};
